import { QuestionnaireQuestionResource } from '@pm/graphql';
import { Modal } from '@pm/ui';
import { useTranslation } from 'react-i18next';

export const QuestionnaireResourcesModal = ({
  resource,
  showModal,
  setShowModal,
}: {
  resource: QuestionnaireQuestionResource;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}) => {
  const { t } = useTranslation('global');
  const modalTitle = resource.title ?? '';
  const closeLabel = t('CloseDialog');

  return (
    <Modal.Root open={showModal} onOpenChange={setShowModal}>
      <Modal.Content
        title={modalTitle}
        ariaLabel={modalTitle}
        closeAriaLabel={closeLabel}
        showXinDialog
      >
        <Modal.Body>{resource.value}</Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
